export const CREATE_USER_URL = {
	label: 'Create User',
	value: '/admin-panel/backoffice-users/create-user',
};

export const LOG_IN_URL = { label: 'Login', value: '/login' };

export const LOG_OUT_URL = { label: 'Logout', value: 'logout' };

export const RESET_URL = { label: 'Reset', value: '/reset' };

export const DASHBOARD_URL = {
	label: 'Dashboard',
	value: '/dashboard',
};

export const MY_PROFILE_URL = {
	label: 'My Profile',
	value: '/profile/profile-settings',
};

export const PROFILE_SETTINGS_URL = {
	label: 'Profile Settings',
	value: '/profile/profile-settings',
};

export const CUSTOM_SETTINGS_URL = {
	label: 'Custom Settings',
	value: '/profile/custom-settings',
};

export const PERMISSIONS_URL = {
	label: 'Permissions',
	value: '/profile/permissions',
};

export const BACKOFFICE_USERS_URL = {
	label: 'Backoffice Users',
	value: '/admin-panel/backoffice-users',
};

export const ROLES_PERMISSIONS_URL = {
	label: 'Roles & Permissions',
	value: '/admin-panel/roles-permissions',
};

export const ACTIVITY_LOG_URL = {
	label: 'Activity Log',
	value: '/admin-panel/activity-log',
};

export const PLAYER_LIST_URL = {
	label: 'Player List',
	value: '/players/player-list',
};

export const PLAYER_DETAILS_URL = {
	label: 'Player Details',
	value: '/players/player-list/:id',
};

export const PLAYER_SESSIONS_URL = {
	label: 'Player Sessions',
	value: '/players/player-sessions',
};

export const PLAYER_TRANSACTIONS_URL = {
	label: 'Player Transactions',
	value: '/players/player-transactions',
};

export const REPORTS_KPIS_URL = {
	label: 'KPIs',
	value: '/reports/kpis',
};

export const REPORTS_GAMBLING_REPORT_URL = {
	label: 'Gambling Report',
	value: '/reports/gambling-report',
};

export const REPORTS_GAMES_REPORT_URL = {
	label: 'Games Report',
	value: '/reports/games-report',
};

export const REPORTS_PARTNERS_REPORT_URL = {
	label: 'Partners Report',
	value: '/reports/partners-report',
};

export const REPORTS_PLAYERS_REPORT = {
	label: 'Players Report',
	value: '/reports/players-report',
};

export const REPORTS_EMAIL_REPORT = {
	label: 'Email Report',
	value: '/reports/email-report',
};

export const REPORTS_EASY_SWIPE_FUNNEL = {
	label: 'EasySwipe Funnel',
	value: '/reports/easy-swipe-funnel',
};

export const PROMOTIONAL_EASY_BOOST_URL = {
	label: 'Easy Boost',
	value: '/promotional-tools/easy-boost',
};

export const PROMOTIONAL_MONEY_DROP_URL = {
	label: 'Money Drop',
	value: '/promotional-tools/money-drop',
};

export const PROMOTIONAL_FREE_SPINS_URL = {
	label: 'Free Spins',
	value: '/promotional-tools/free-spins',
};

export const GAMES_URL = {
	label: 'Games',
	value: '/games/casino-games',
};

export const GAME_CATEGORIES_URL = {
	label: 'Game Categories',
	value: '/games/game-categories',
};

export const GAME_PROVIDERS_URL = {
	label: 'Game Providers',
	value: '/games/game-providers',
};

export const GAME_PARTNERS_URL = {
	label: 'Game Partners',
	value: '/games/game-partners',
};
